import React from 'react'

import { cn } from '@/lib/utils'

import { StylesProps } from '../page-header.types'
import { HeaderBanner } from '../shared/header-banner'
import { HeaderDescription } from '../shared/header-description'
import { HeaderLogo } from '../shared/header-logo'
import { HeaderName } from '../shared/header-name'
import { HeaderSocialIcons } from '../shared/header-social-icons'

export const GeexWebDesignerPageHeader = ({
  page,
  hasBannerImage,
  hasLogoImage,
  hasName,
  hasDescription,
  forceMobile,
  ...props
}: StylesProps) => {
  return (
    <>
      <div className={cn('relative', { 'lg:pt-fluid-14': !forceMobile })}>
        <HeaderBanner
          media={page?.bannerMedia}
          className={cn('absolute size-full', {
            'lg:rounded-t-page-widget': !forceMobile,
          })}
          style={{
            WebkitMaskImage: `linear-gradient(to bottom, white 70%, transparent 100%)`,
            maskImage: `linear-gradient(to bottom, white 70%, transparent 100%)`,
          }}
          {...props}
        />

        <div
          className={cn('relative px-fluid-3 bottom-0', {
            'pt-fluid-72 pb-fluid-8 -mb-fluid-4': hasBannerImage,
            'pt-fluid-8 pb-fluid-8': !hasBannerImage,
          })}
        >
          <div className="relative">
            {(hasLogoImage || hasDescription || hasName) && (
              <div
                className="page-header-block ft-widget-wrapper absolute left-0 top-0 size-full border-none!"
                style={{
                  maskImage: `linear-gradient(black, black),url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQ3IiBoZWlnaHQ9IjM3IiB2aWV3Qm94PSIwIDAgMTQ3IDM3IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTAuMzQzNzUgMEMxMC4zMDcyIDAgMTkuOTI5NCAzLjYxNDk0IDI3LjQxMDkgMTAuMTY4OEw0Ni40MzIxIDI2LjgzMTJDNjEuOTA5NyA0MC4zODk2IDg1LjA4ODkgNDAuMzg5NiAxMDAuNTY2IDI2LjgzMTJMMTE5LjU4OCAxMC4xNjg4QzEyNy4wNjkgMy42MTQ5NCAxMzYuNjkxIDAgMTQ2LjY1NSAwSDAuMzQzNzVaIiBmaWxsPSIjRDlEOUQ5Ii8+Cjwvc3ZnPgo=')`,
                  maskRepeat: 'no-repeat',
                  maskPosition: 'center top',
                  maskComposite: 'exclude',
                  WebkitMaskImage: `linear-gradient(black, black),url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQ3IiBoZWlnaHQ9IjM3IiB2aWV3Qm94PSIwIDAgMTQ3IDM3IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTAuMzQzNzUgMEMxMC4zMDcyIDAgMTkuOTI5NCAzLjYxNDk0IDI3LjQxMDkgMTAuMTY4OEw0Ni40MzIxIDI2LjgzMTJDNjEuOTA5NyA0MC4zODk2IDg1LjA4ODkgNDAuMzg5NiAxMDAuNTY2IDI2LjgzMTJMMTE5LjU4OCAxMC4xNjg4QzEyNy4wNjkgMy42MTQ5NCAxMzYuNjkxIDAgMTQ2LjY1NSAwSDAuMzQzNzVaIiBmaWxsPSIjRDlEOUQ5Ii8+Cjwvc3ZnPgo=')`,
                  WebkitMaskRepeat: 'no-repeat',
                  WebkitMaskPosition: 'center top',
                  WebkitMaskComposite: 'exclude',
                }}
              />
            )}

            <div
              className={cn(
                'relative flex flex-col space-y-fluid-2 px-fluid-4 py-fluid-6',
                {
                  'pt-10': hasLogoImage,
                },
              )}
            >
              <HeaderLogo
                media={page?.logoMedia}
                {...props}
                className="absolute left-1/2 top-0 -translate-x-1/2 -translate-y-1/2 rounded-full"
                sizeClassName="size-16"
                size={64}
              />

              <HeaderName
                name={page?.name}
                {...props}
                className="text-center text-fluid-4xl text-page-heading-text"
              />

              <HeaderDescription
                description={page?.description}
                {...props}
                className="text-center text-fluid-xl text-page-body-text"
              />
            </div>
          </div>

          <HeaderSocialIcons
            socialIcons={page?.socialIcons}
            {...props}
            className="mt-fluid-1.5 justify-center"
            primaryClassName="p-fluid-3 page-header-primary-button flex-1"
            secondaryClassName="p-fluid-3 page-header-secondary-button"
            showPrimaryLabel
          />
        </div>
      </div>
    </>
  )
}
